__turbopack_context__.v({
  "accordionSlideOverwrite": "multiCurrencyField-module-scss-module__gI6b5q__accordionSlideOverwrite",
  "addButton": "multiCurrencyField-module-scss-module__gI6b5q__addButton",
  "deleteButton": "multiCurrencyField-module-scss-module__gI6b5q__deleteButton",
  "deleteSpacer": "multiCurrencyField-module-scss-module__gI6b5q__deleteSpacer",
  "fadeIn": "multiCurrencyField-module-scss-module__gI6b5q__fadeIn",
  "fadeOut": "multiCurrencyField-module-scss-module__gI6b5q__fadeOut",
  "optionRow": "multiCurrencyField-module-scss-module__gI6b5q__optionRow",
  "scaleIn": "multiCurrencyField-module-scss-module__gI6b5q__scaleIn",
  "scaleOut": "multiCurrencyField-module-scss-module__gI6b5q__scaleOut",
  "summation": "multiCurrencyField-module-scss-module__gI6b5q__summation",
  "zoomIn": "multiCurrencyField-module-scss-module__gI6b5q__zoomIn",
  "zoomOut": "multiCurrencyField-module-scss-module__gI6b5q__zoomOut",
});
